import {ChangeDetectionStrategy, Component, ElementRef, forwardRef, ViewChild} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {DisplaySymbol} from '../../common/display-symbol';
import {AutocompleteInputComponent} from '../autocomplete-input';
import {Deliverable} from '../dex/dex-streaming/types/deliverable';
import {DeliverableAutocompleteDirective} from './deliverable-autocomplete/deliverable-autocomplete.directive';
import {DeliverableAutocompleteModule} from './deliverable-autocomplete/deliverable-autocomplete.module';

@Component({
    selector:        'deliverable-input',
    templateUrl:     './deliverable-input.component.html',
    styleUrl:        '../security-input/security-input.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers:       [
        {
            provide:     NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DeliverableInputComponent),
            multi:       true
        }
    ],
    imports:         [
        DeliverableAutocompleteModule
    ]
})
export class DeliverableInputComponent extends AutocompleteInputComponent<Deliverable> {

    @ViewChild(DeliverableAutocompleteDirective, {static: true})
    public override innerValueAccessor: DeliverableAutocompleteDirective;

    @ViewChild(DeliverableAutocompleteDirective, {read: ElementRef, static: true})
    public override innerInputElementRef: ElementRef;

    public displaySymbol: DisplaySymbol;

    public override writeValue(d: Deliverable): void {
        super.writeValue(d);

        this.updateDisplaySymbol();
    }

    protected override innerPropagateOnChange(d: Deliverable): void {
        super.innerPropagateOnChange(d);

        this.updateDisplaySymbol();
    }

    private updateDisplaySymbol(): void {
        this.displaySymbol = {
            symbol:     this.value?.symbol,
            exchange:   '',
            displayStr: this.value?.symbol
        };
    }

}
